import { Article, Ticket } from '@wix/answers-api';
import { Box, Heading } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FunctionComponent } from 'react';

import { FollowedContent } from './FollowedContent';
import { MyTickets } from './MyTickets';
import { DATA_HOOKS } from '../../dataHooks';

import css from './index.module.scss';

export type MyActivityProps = {
  unfollowContnet: (articleId: string) => void;
  followedContent: Article[];
  tickets: Ticket[];
  followedContentCount: number;
  ticketsCount: number;
  onShowMoreFollowedContentClick: () => void;
  onShowMoreTicketsClick: () => void;
};

export const MyActivity: FunctionComponent<MyActivityProps> = ({
  unfollowContnet,
  followedContent,
  tickets,
  followedContentCount,
  ticketsCount,
  onShowMoreFollowedContentClick,
  onShowMoreTicketsClick,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      className={css.wrapper}
      dataHook={DATA_HOOKS.MY_ACTIVITY}
      direction="vertical"
    >
      <Heading
        dataHook={DATA_HOOKS.MY_ACTIVITY_TITLE}
        className={css.sectionTitle}
      >
        {t('user.my-activity.title')}
      </Heading>
      <MyTickets
        onShowMoreClick={onShowMoreTicketsClick}
        tickets={tickets}
        ticketsCount={ticketsCount}
      />
      <FollowedContent
        onShowMoreClick={onShowMoreFollowedContentClick}
        followedContentCount={followedContentCount}
        unfollowContnet={unfollowContnet}
        followedContent={followedContent}
      />
    </Box>
  );
};
